<div class="quote-container">
  <div class="content">
    <div class="cart-info">
      <kion-basket-info
        [deviceCart]="deviceCart$ | async"
        [device]="device$ | async"
        [roles]="roles$ | async"
        (updateStatus)="updateStatus($event)"
        (deleteQuote)="deleteQuote()"
      ></kion-basket-info>
    </div>
    <div class="warning" *ngIf="deviceCart$ | async as cart">
      <kion-warning-banner
        *ngIf="cart.entries.length > 1"
        [header]="'basket.warning.compatibility.headline' | translate"
        [body]="'basket.warning.compatibility.description' | translate"
      ></kion-warning-banner>
    </div>
    <div class="device-short-info">
      <kion-device-short-info
        [device]="device$ | async"
      ></kion-device-short-info>
    </div>
    <div class="feature-info">
      <kion-feature-quote-list
        [deviceCart]="deviceCart$ | async"
        [device]="device$ | async"
        [roles]="roles$ | async"
        [features]="deviceFeatures$ | async"
        (deleteFeature)="deleteFeature($event)"
      ></kion-feature-quote-list>
    </div>
    <div class="order-info" *ngIf="deviceCart$ | async as cart">
      <div class="spacer hideOnPhone"></div>
      <div class="sum">
        <div class="pricing {{ (hasApproverRole$ | async) ? '' : 'no-border' }}">
          <div class="label">
            <div class="amount">
              {{ 'basket.summary.totalAmount.headline' | translate }}
            </div>
            <div class="vat">
              {{ 'basket.summary.totalAmount.vat.excluded' | translate }}
            </div>
          </div>
          <div class="value">{{ cart.totalPrice.formattedValue }}</div>
        </div>
      </div>
      <div class="spacer hideOnPhone"></div>
      <div class="buy" *ngIf="(hasApproverRole$ | async) && !(unhealthy$ | async)">
        <div class="checkboxes" *ngIf="boxes">
          <kion-checkbox
            *ngIf="boxes"
            [boxes]="boxes"
            (requiredSelected)="toggleBuyable($event)"
          ></kion-checkbox>
        </div>
        <kion-button
          [title]="'quote.button.buy' | translate"
          mode="primary"
          [disabled]="!(isBuyable | async)"
          [isLoading]="isBuying"
          [showTextWhileLoading]="true"
          (clicked)="buy()"
        ></kion-button>
      </div>
    </div>
    <div class="additional-info" [formGroup]="form">
      <div class="groupheader">
        <div class="heading">
          {{ 'basket.orderInformation.headline' | translate }}
        </div>
      </div>
      <div class="info">
        <div class="po-number">
          <div class="label">
            <label for="poNumberField">{{'basket.orderInformation.poNumber.headline' | translate}}</label>
          </div>
          <input
            *ngIf="hasBuyerRole$ | async; else noNumberRole"
            type="text"
            id="poNumberField"
            formControlName="poNumber"
            placeholder="{{'basket.orderInformation.poNumber.placeholder' | translate}}"
          />
          <ng-template #noNumberRole>
            <div class="poNumber-only-view" *ngIf="deviceCart$ | async as cart">
              {{cart.purchaseOrderNumber ? cart.purchaseOrderNumber : ('basket.orderInformation.poNumber.noData' | translate)}}
            </div>
          </ng-template>
        </div>
        <div class="date"></div>
        <div class="note">
          <div class="label">
            <label for="note">{{'basket.orderInformation.poNote.headline' | translate}}</label>
          </div>
          <textarea
            *ngIf="hasBuyerRole$ | async; else noNoteRole"
            id="note"
            formControlName="poNote"
            placeholder="{{'basket.orderInformation.poNote.placeholder' | translate}}"
          ></textarea>
          <ng-template #noNoteRole>
            <div class="note-only-view" *ngIf="deviceCart$ | async as cart">
              {{cart?.userComment ? cart?.userComment.text : ('basket.orderInformation.poNote.noData' | translate)}}
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="additional-info" [formGroup]="formCcRecipients">
      <div class="groupheader">
        <div class="heading">
          {{ 'basket.orderInformation.poCcRecipients.headline' | translate }}
        </div>
      </div>
      <div class="info">
        <div class="po-number">
          <input
            *ngIf="hasBuyerRole$ | async; else noCcRecipientsRole" (keyup.enter)="addCcRecipient($event)"
            type="text"
            id="poCcRecipientField"
            formControlName="poCcRecipients"
            placeholder="{{'basket.orderInformation.poCcRecipient.placeholder' | translate}}"
          />
          <ng-template #noCcRecipientsRole>
            <div class="poNumber-only-view" *ngIf="deviceCart$ | async as cart">
              {{cart.additionalCcEmails ? cart.additionalCcEmails : ('basket.orderInformation.poNumber.noData' | translate)}}
            </div>
          </ng-template>
        </div>
        <div class="date"></div>
        <div class="note">
          <kion-button
            [disabled]="(isAddCcRecipientButtonEnabled$ | async) === false"
            *ngIf="hasBuyerRole$ | async"
            [title]="'feature.cart.button.add' | translate"
            (clicked)="addCcRecipient($event)"
          ></kion-button>
        </div>
      </div>
      <div *ngIf="ccEmails$ | async as ccEmails" class="ccEmailsDeleteButtons">
        <div *ngFor="let ccEmail of ccEmails">
          <div class="btn-delete" (click)="deleteCcRecipient(ccEmail, $event)">
            <div tabindex="1" class="content">
              <div class="description">
                {{ ccEmail }}
              </div>
              <div class="img">
                <svg fill="#000000" width="26px" height="26px" viewBox="0 0 0.78 0.78" version="1.2" baseProfile="tiny"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.39 0.13c-0.143 0 -0.26 0.117 -0.26 0.26s0.117 0.26 0.26 0.26 0.26 -0.117 0.26 -0.26 -0.117 -0.26 -0.26 -0.26zm0.121 0.335a0.033 0.033 0 1 1 -0.046 0.046L0.39 0.436 0.315 0.51a0.033 0.033 0 0 1 -0.046 0 0.033 0.033 0 0 1 0 -0.046L0.345 0.39 0.269 0.315A0.033 0.033 0 1 1 0.315 0.27L0.39 0.345 0.464 0.27a0.033 0.033 0 1 1 0.046 0.046L0.436 0.39l0.075 0.075z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

